export const pagesConsts = {
    GET_PAGES_LIST: "GET_PAGES_LIST",
    CREATE_PAGE: "CREATE_PAGE",
    UPDATE_PAGE_BY_ID: "UPDATE_PAGE_BY_ID",
    DELETE_PAGE_BY_ID: "DELETE_PAGE_BY_ID",
};